<template>
  <v-container class="unsubscribe-page">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="pa-6 mt-6">
          <div class="text-center mb-6">
            <img
              src="/img/linkbook-logo.png"
              alt="Linkbook.io Logo"
              width="80"
              class="mb-4"
            />
            <h1 class="text-h4 mb-2">Email Preferences</h1>
          </div>

          <v-alert v-if="error" type="error" class="mb-4">
            {{ error }}
          </v-alert>

          <v-alert v-if="success" type="success" class="mb-4">
            {{ success }}
          </v-alert>

          <div v-if="loading" class="text-center py-6">
            <v-progress-circular
              indeterminate
              color="primary"
              size="50"
            ></v-progress-circular>
            <p class="mt-4">Processing your request...</p>
          </div>

          <div v-else-if="!success && !error" class="py-2">
            <p class="mb-4">
              Check the types of emails you would like to unsubscribe from:
            </p>

            <v-checkbox
              v-model="emailPreferences.marketingEmails"
              label="Marketing Emails - Stop receiving special offers, promotions, and other marketing communications"
              color="primary"
              hide-details
              class="mb-4"
            ></v-checkbox>

            <v-checkbox
              v-model="emailPreferences.featureAnnouncements"
              label="Feature Announcements - Stop receiving updates about new LinkBook features and improvements"
              color="primary"
              hide-details
              class="mb-2"
            ></v-checkbox>

            <p class="text--secondary mt-4 mb-4">
              You can also manage your email preferences anytime in your
              <router-link to="/profile#email">profile settings</router-link>.
            </p>

            <v-divider class="my-4"></v-divider>

            <v-btn
              block
              color="primary"
              @click="confirmUnsubscribe"
              :loading="processing"
              :disabled="
                !emailPreferences.featureAnnouncements &&
                  !emailPreferences.marketingEmails
              "
            >
              Unsubscribe from Selected Emails
            </v-btn>
          </div>

          <div v-if="success || error" class="text-center mt-4">
            <v-btn color="primary" to="/" text>
              Return to Home
            </v-btn>
            <div v-if="success" class="mt-2">
              <v-btn color="secondary" to="/profile#email" text>
                Go to Profile Settings
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from '@/api'

export default {
  name: 'Unsubscribe',
  metaInfo: {
    title: 'Unsubscribe',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content: 'Manage your email preferences on LinkBook.io'
      }
    ]
  },
  data() {
    return {
      token: null,
      email: null,
      loading: true,
      processing: false,
      error: null,
      success: null,
      emailPreferences: {
        featureAnnouncements: false,
        marketingEmails: false
      }
    }
  },
  mounted() {
    this.validateToken()
  },
  methods: {
    validateToken() {
      this.token = this.$route.query.token
      this.email = this.$route.query.email

      if (!this.token || !this.email) {
        this.error =
          'Invalid unsubscribe link. Please ensure you clicked the correct link from your email.'
        this.loading = false
        return
      }

      this.loading = false
    },
    async confirmUnsubscribe() {
      this.processing = true

      try {
        const response = await api.processUnsubscribe(this.token, this.email, {
          featureAnnouncements: this.emailPreferences.featureAnnouncements,
          marketingEmails: this.emailPreferences.marketingEmails
        })

        if (response.error) {
          this.error = response.error
        } else {
          this.success =
            'Your email preferences have been successfully updated. You can manage these settings anytime in your profile.'
        }
      } catch (error) {
        this.error =
          error.message || 'An error occurred while processing your request.'
      } finally {
        this.processing = false
      }
    }
  }
}
</script>

<style scoped>
.unsubscribe-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
}
</style>
